/**
 *
 * Created by sergo on 04.07.17.
 */
// CONSTANTS

export const URL_HOME = '/'; // рут
export const URL_LOGIN = '/login'; // логин
export const URL_SIGNUP = '/signup'; // регистрация
export const URL_SIGNUP_C = `${ URL_SIGNUP }/:code`; // регистрация
export const URL_RESTOREPWD = '/restorepwd'; // восстановление пароля, шаг 1
export const URL_RESTOREPWD_RESET = '/restorepwd/reset/:code'; // восстановление пароля шаг 2 (сброс пароля)

export const URL_FEEDBACK = '/feedback'; // обратная связь пользователей консоли (список обращений)
export const URL_FEEDBACK_MY = '/feedback/my'; // свои обращения (доступно любому авторизованному)
export const URL_USERS = '/users'; // пользователи
export const URL_USERS_VIEW_ONE = '/users'; // пользователи
export const URL_USERS_VIEW_ONE_C = '/users/:code'; // просмотр пользователя
export const URL_USERS_ONLINE = '/users/online'; // пользователи онлайн

export const URL_SERVICES = '/services'; // настройка сервисов
export const URL_POSITIONS = '/positions'; // номенклатура позиций
export const URL_PRICELISTS = '/pricelists'; // прайс-листы
export const URL_PRICELISTS_VIEW_ONE = '/pricelists'; // просмотр прайс-листа URL_PRICELISTS_VIEW_ONE
export const URL_PRICELISTS_VIEW_ONE_C = `${ URL_PRICELISTS_VIEW_ONE }/:priceListId/`; // просмотр прайс-листа
export const URL_PRICELIST_OFFICES = '/pricelists/offices'; // привязка офиса к прайс-листу
export const URL_INFORMERS = '/reference/informer'; // информеры - краткие форму с информацией о товаре
export const URL_ROLES = '/roles'; // настройка ролей
export const URL_ROLE_EDIT = '/roles/edit/:role'; // редактирование роли
export const URL_OPERATIONS = '/operations'; // настройка функционала
export const URL_PERMISSIONS = '/permissions'; // настройка прав
export const URL_PARTNER_PERMISSIONS = '/partner/permissions'; // настройка прав
export const URL_PERMISSIONS_BY_OP = '/operations/permissions'; // настройка прав
export const URL_PERMISSIONS_BY_OP_С = '/operations/permissions/:id'; // настройка прав

export const URL_PARTNERS = '/partners'; // партнеры
export const URL_PARTNERS_VIEW_ONE = '/partners'; // партнеры
export const URL_PARTNERS_CREATE_ONE = '/partners/create'; // партнеры
export const URL_PARTNERS_VIEW_ONE_C = '/partners/:code'; // просмотр партнера
export const URL_PARTNERS_CONTRACT_VIEW_ONE = '/partners/:code/contract'; // просмотр договора партнера
export const URL_PARTNERS_CONTRACT_VIEW_ONE_C = '/partners/:code/contract/:contract_code'; // просмотр договора партнера
export const URL_PARTNERS_CONTRACT_NEW = '/partners/:code/contract/new'; // просмотр договора партнера
export const URL_DIVISIONS = '/divisions'; // партнеры

export const URL_DOC_TEMPLATES = '/doc-templates'; // бланки для автозаполнения
export const URL_INSURANCE = '/insurance'; // страховые
export const URL_INSURANCE_VIEW_ONE_C = '/insurance/:code'; // страховые
export const URL_INSURANCE_CHANGES = '/insurance/changes';

export const URL_ORDERS = '/orders'; // заявки
export const URL_ORDERS_VIEW_ONE = '/orders'; // просмотр заявки URL_ORDER_ONE
export const URL_ORDERS_VIEW_ONE_C = `${ URL_ORDERS_VIEW_ONE }/:code`; // просмотр заявки
export const URL_ORDERS_VIEW_ONE_C_AUTO = `${ URL_ORDERS_VIEW_ONE }/:code/:command`; // просмотр заявки c выставление счета
export const URL_ORDERS_VIEW_ONE_EVACUATOR = '/orders/evacuator'; // просмотр заявки на эвакуацию
export const URL_ORDERS_VIEW_ONE_EVACUATOR_C = '/orders/evacuator/:code'; // просмотр заявки на эвакуацию
export const URL_ORDERS_VIEW_ONE_TECH_SERVICE = '/orders/techservice'; // просмотр заявки на тех.помощь (топливо, запаска, вскрытие, запуск двигателя)
export const URL_ORDERS_VIEW_ONE_TECH_SERVICE_C = '/orders/techservice/:code'; // просмотр заявки на тех.помощь
export const URL_EVACUATOR_ORDERS = '/evacuator/orders'; // активные заявки на эвакуацию
export const URL_AVARCOM_ORDERS = '/avarcom/orders'; // активные заявки на аваркомов
export const URL_TBANK_AVARCOM_ORDERS = '/tavarcom/orders'; // активные заявки на аваркомов
export const URL_TBANK_AVARCOM_EVACUATION_ORDERS = '/tavarcom/orders/evacuation'; // активные заявки на эвакуацию от Т-Аваркомов
export const URL_ORDERS_FIND_BY_VALUES = '/orders/find/by/values'; // активные заявки на аваркомов
export const URL_TIRE_FITTING_ORDER_VIEW_ONE = '/tire/fitting/order'; // просмотр заявки по шиномонтажу
export const URL_TIRE_FITTING_ORDER_VIEW_ONE_C = '/tire/fitting/order/:code'; // просмотр заявки по шиномонтажу
export const URL_TIRE_STORAGE_ORDER_VIEW_ONE = '/tire/storage/order'; // просмотр заявки по хранению
export const URL_TIRE_STORAGE_ORDER_VIEW_ONE_C = '/tire/storage/order/:code'; // просмотр заявки по хранению
export const URL_TIRE_FITTING_ORDERS = '/tire/fitting'; // активные заявки на аваркомов
export const URL_PARTNER_CAR_PARK = '/car/park'; // список партнёров, для работы с автопарком
export const URL_LOSS_ADJUSTMENT_ORDER_VIEW_ONE = '/loss/adjustment/order'; // просмотр заявки по урегулированию убытков
export const URL_LOSS_ADJUSTMENT_ORDER_VIEW_ONE_C = '/loss/adjustment/order/:code'; // просмотр заявки по урегулированию убытков
export const URL_LOSS_ADJUSTMENT_ORDERS = '/loss/adjustment'; // урегулирование убытков (список заявок)
export const URL_ORDER_DOC_PREVIEW = '/orders/doc/preview'; // предпросмотр PDF-бланка заявки с редактированием полей
export const URL_ORDER_DOC_PREVIEW_C = `${ URL_ORDER_DOC_PREVIEW }/:orderId/:templateId`;
export const URL_STATUS_NOTICE_APPOINTMENTS = '/status/notice'; // Форма управление статусами записей и возвратами в Совкомбанке

// :code  - id заявки
// :command - доб.команда (/auto - автоматом сгенерить счёт )

export const URL_ORDERS_CREATE_ONE = '/orders/create/'; // просмотр заявки
export const URL_ORDERS_ARCHIVE = '/orders/archive'; // архив заявок
export const URL_ORDERS_COMMUNICATION_EXPIRED = '/contacts/expired'; // контакты
export const URL_ORDERS_COMMUNICATION_EXPIRED_BY_OFFICE = '/contacts/expired/:code/:type'; // контакты по конкретной территории

export const URL_BILLS = '/bills'; // пользователи
export const URL_BILLS_VIEW_ONE = '/bills'; // пользователи
export const URL_BILLS_VIEW_ONE_C = `${ URL_BILLS_VIEW_ONE }/:code`; // просмотр пользователя

export const URL_VZR_POLICIES = '/vzr/policies';
export const URL_VZR_POLICY_VIEW_ONE = '/vzr/policies';
export const URL_VZR_POLICY_VIEW_ONE_C = `${ URL_VZR_POLICY_VIEW_ONE }/:id/`;
export const URL_VZR_POLICY_CREATE_ONE = '/vzr/policies/create';

export const URL_VZR_PAYMENTS = '/vzr/payments';
export const URL_VZR_PAYMENT_VIEW_ONE = '/vzr/payments';
export const URL_VZR_PAYMENT_VIEW_ONE_C = `${ URL_VZR_PAYMENT_VIEW_ONE }/:id/`;
export const URL_VZR_PAYMENT_CREATE_ONE = '/vzr/payments/create';

export const URL_VZR_PROMOCODES = '/vzr/promocodes';
export const URL_VZR_PROMOCODES_VIEW_ONE = '/vzr/promocodes';
export const URL_VZR_PROMOCODES_VIEW_ONE_C = `${ URL_VZR_PROMOCODES_VIEW_ONE }/:id/`;
export const URL_VZR_PROMOCODES_CREATE_ONE = '/vzr/promocodes/create';

export const URL_VEHICLE_CHANGES = '/vehicle/changes';
export const URL_VEHICLE_CHANGES_C = `${ URL_VEHICLE_CHANGES }/:group/`;
export const URL_CARMEN_COMPATIBILITY = '/vehicle/carmen-compat/';
export const URL_CARMEN_USERS = '/carmen/users/';

export const URL_CLIENT_SEARCH = '/client/search';
export const URL_CLIENT_VIEW = '/client';
export const URL_CLIENT_VIEW_C = '/client/:id/';

export const URL_VEHICLE_SEARCH = '/vehicle/search';
export const URL_VEHICLE_VIEW = '/vehicle';
export const URL_VEHICLE_VIEW_C = '/vehicle/:id/';

export const URL_PROFILE = '/profile'; // профиль
export const URL_CONFIG = '/config/common'; // настройки (профиль)
export const URL_CRON_TASK = '/config/crontask'; // настройки (профиль)
export const URL_PERSONAL_STATISTIC = '/personal/statistic'; // персональная статистика
export const URL_STREAM_BALANCE = '/stream/balance'; // персональная статистика
export const URL_MAX_CHANNEL = '/max/channels'; // персональная статистика
export const URL_CONFIG_WORKSPACE = '/config/workspace'; // настройки рабочего места (офис, исполнители)
export const URL_WEBSOCKET_LOG = '/websocket/log';

export const URL_UNIVERSAL_REFERENCE = '/universalreference'; // настройка прав

// Sovcombank check page
export const URL_CHECK_SOVCOMBANK = '/check/sovcombank';

export const URL_REPORTS = '/reports'; // отчеты
export const URL_REPORTS_A3_PAID_FINE = '/reports/a3paidfine'; // оплаченные штрафы A3
export const URL_REPORTS_A3_AVAILABILITY = '/reports/a3availability'; // доступность сервисов A3
export const URL_REPORTS_CLIENT_REGISTRATION = '/reports/client/registration'; // доступность сервисов A3
export const URL_REPORTS_SETTLEMENT_WITH_PARTNER = '/reports/settlements-with-partners'; // отчёт по партнёрам
export const URL_REPORTS_RECONCILIATION = '/reports/reconciliation'; // акты по взаиморасчёта ?
export const URL_REPORTS_RECONCILIATION_VIEW_ONE = '/reconciliation'; // просмотр прайс-листа URL_PRICELISTS_VIEW_ONE
export const URL_REPORTS_RECONCILIATION_VIEW_ONE_C = `${ URL_REPORTS_RECONCILIATION_VIEW_ONE }/:reconciliationId/`; // просмотр прайс-листа
export const URL_REPORTS_MOBILE_STATISTICS = '/reports/mobile/statistics'; // акты по взаиморасчёта
export const URL_REPORTS_OPERATOR_STATISTICS = '/reports/operator/statistics'; // статистика  регистрации клиентов по операторам
export const URL_REPORTS_MOBILE_V2 = '/reports/mobile/v2'; // Отчёт по приложению для Николая V2
export const URL_REPORT_BONUSES = '/reports/bonuses'; // Отчёт по бонусам
export const URL_UTM_REPORT_APPOINTMENTS = '/reports/utm/appointments'; // Отчёт по UTM в записях
export const URL_UTM_REPORT_ORDERS = '/reports/utm/orders'; // Отчёт по UTM в заявках
export const URL_SOVCOMBANK_APPOINTMENTS_REPORT = '/reports/sovcombank/appointments'; // Отчёт по записям для Совкомбанка
export const URL_TIRE_SERVICE_ORDERS_REPORT = '/reports/tire/service/analytics'; // Аналитика заявок ШМ (svc-support)
export const URL_TIRE_STORAGE_ORDERS_REPORT = '/reports/tire/storage/analytics'; // Аналитика хранения (svc-support)
export const URL_CLIENT_STATISTIC_REPORT = '/reports/client/statistic/analytics'; // Аналитика клиентов (svc-support; включает секцию «Установка приложений»)
export const URL_EVACUATOR_REFUSAL_REPORT = '/reports/evacuator/refusal'; // Отчёт по отказам в эвакуации
export const URL_T_AVARCOM_REPORT = '/reports/t/avarcom'; // Отчёт по отказам в эвакуации
export const URL_T_AVARCOM_EVACUATION_REPORT = '/reports/t/avarcom/evacuation'; // Отчёт по отказам в эвакуации
export const URL_T_BANK_CHECK_REPORT = '/reports/tbank/check'; // Отчёт по контролю оплат в Т-Банке
export const URL_PROMO_STATISTICS_REPORT = '/reports/promo/statistics'; // Отчёт по контролю промоакций
export const URL_BONUS_STATISTICS_REPORT = '/reports/bonus/statistics'; // Отчёт по контролю движения бонусов
export const URL_WHEELS_STORAGE_REPORT = '/reports/wheels/storage'; // Отчёт по хранению колёс
export const URL_CHECK_TYRE_SERVICE_REPORT = '/reports/tyre/service'; // Отчёт по контролю шиномонтажа
export const URL_PAID_INVOICE_REPORT = '/reports/paid/invoice'; // Отчёт по контролю шиномонтажа
export const URL_CLIENT_FOR_MARKETING_REPORT = '/reports/client'; // Отчёт по клиентам для маркетинга
export const URL_PERSONAL_DATA_REPORT = '/reports/personal-data'; // Персональные данные (клиенты ВезёмКолёса с согласиями)
export const URL_TYRE_CHANGES_REPORT = '/reports/tyre/changes'; // Отчёт по перекидкам колёс
export const URL_SCHEDULER_DURATION_REPORT = '/reports/scheduler/duration'; // Отчёт по  продолжительности записи
export const URL_TIRE_SERVICE_REPORT = '/reports/tire/service'; // Отчёт по статистике шинного сервиса
export const URL_LOSS_ADJUSTMENT_REPORT = '/reports/loss/adjustment'; // Отчёт по статистике урегулирования убытков
export const URL_LOSS_ADJUSTMENT_USER_REPORT = '/reports/loss/adjustment/user'; // Отчёт по сотрудника пл урегулированию убытков

export const URL_TBANK_LEGALS_REPORT = '/reports/tbank/legals';
export const URL_TBANK_MULTI_PAYMENTS = '/reports/tbank/multi/payments';

export const URL_SCHEDULER_POST = '/scheduler/post'; // посты офисов
export const URL_SCHEDULER_WEEK = '/scheduler/week'; // справочник - расписание на неделю
export const URL_SCHEDULER_HALF_YEAR = '/scheduler/halfyear'; // справочник - Рабочие дни на полгода
export const URL_SCHEDULER_FEDERAL = '/scheduler/federal'; // журнал записи
export const URL_SCHEDULER_V2_STAND = '/scheduler/v2-stand'; // DEV-стенд планировщиков V2 (не для прода, см. routes.js)
export const URL_SCHEDULER_DELETED_APPOINTMENTS = '/scheduler/deleted'; // удалённые записи
export const URL_SCHEDULER_TIRE_TRANSFER = '/scheduler/tire/transfer'; // удалённые записи
export const URL_SCHEDULER_TIRE_FIFTH_WHEEL = '/scheduler/tire/fifth-wheel'; // записи «5 колеса»
export const URL_SCHEDULER_TIMELINE = '/scheduler/timeline'; // timeline для УУ
export const URL_SCHEDULER_TIMELINE_TIRE_SERVICE = '/scheduler/timeline/tire'; // timeline для ШМ

export const URL_SERVICE_CARD_TYPE = '/card/types'; // сервисные карты
export const URL_PROMO_REFERENCE = '/promo/reference'; // список промоакций
export const URL_PROMO_REFERENCE_ONE_C = `${ URL_PROMO_REFERENCE }/:id/`;

export const URL_SEO_PAGES_REFERENCE = '/seo/tree'; // дерево промоакций
export const URL_SEO_REVIEW_REFERENCE = '/seo/review'; // дерево промоакций
export const URL_SEO_BLOG_REFERENCE = '/seo/blog'; // статьи блога
export const URL_SEO_BANNERS_REFERENCE = '/seo/banner'; // статьи блога
export const URL_TYRE_REFERENCE = '/tyre/reference'; // справочник шин

export const URL_QR_CODES = '/qrcodes'; // справочник шин

export const URL_GO_BACK = 'GOBACK'; // не URL - инструкция вернуться назад

export const FREE_URLS = [
  URL_LOGIN,
  URL_SIGNUP,
  URL_RESTOREPWD,
  URL_RESTOREPWD_RESET,
];

/**
 * меню навигации по сайту
 * суть: создать 2х уровневое дерево
 *
 * Структура (доменная, после аудита 2026): один route — одно место в меню.
 *  - сначала определяются «листья» (пункты-ссылки) с url/operation,
 *  - затем top-level разделы ($... с kids),
 *  - затем порядок разделов в NAVI.
 * Порядок пунктов внутри раздела = порядок в kids (сортировка по sortOrder в
 * SideBarMenu фактически не применяется). sortOrder/eventKey оставлены как
 * стабильные ключи рендера.
 */
const emptyURL = 'EMPTY';
const $Desktop = {
  url: URL_HOME,
  title: 'Рабочий стол',
  hide: true,
  sortOrder: 1,
  eventKey: 1,
};

const $Orders = {
  url: URL_ORDERS,
  title: 'Активные заявки',
  sortOrder: 21,
  eventKey: 21,
  operation: 'order.active',
  typeOfBadge: 1, // тип для отрисовки количества заявок в БД
};
const $OrdersArchive = {
  url: URL_ORDERS_ARCHIVE,
  title: 'Заявки в архиве',
  sortOrder: 22,
  eventKey: 22,
  operation: 'order.archive',
  typeOfBadge: 2, // тип для отрисовки количества заявок в БД
};
const $ContactExpired = {
  url: URL_ORDERS_COMMUNICATION_EXPIRED,
  title: 'Просроченные контакты',
  sortOrder: 23,
  eventKey: 23,
  operation: 'order.communication',
  // typeOfBadge: 2, // тип для отрисовки количества заявок в БД
};
const $EvacuatorOrders = {
  url: URL_EVACUATOR_ORDERS,
  title: 'Эвакуация и техпомощь',
  sortOrder: 24,
  eventKey: 24,
  operation: 'order.evacuator',
};
const $AvarcomOrders = {
  url: URL_AVARCOM_ORDERS,
  title: 'Аваркомы',
  sortOrder: 25,
  eventKey: 25,
  operation: 'order.avarcom',
};
const $TBankAvarcomOrders = {
  url: URL_TBANK_AVARCOM_ORDERS,
  title: 'Т-Аваркомы',
  sortOrder: 26,
  eventKey: 26,
  operation: 'order.tbank.avarcom',
};
const $TBankAvarcomEvacuationOrders = {
  url: URL_TBANK_AVARCOM_EVACUATION_ORDERS,
  title: 'Т-Эвакуация',
  sortOrder: 27,
  eventKey: 27,
  operation: 'order.tbank.avarcom',
};
const $FindOrdersByMassiveValues = {
  url: URL_ORDERS_FIND_BY_VALUES,
  title: 'Поиск заявок по значениям',
  sortOrder: 28,
  eventKey: 28,
  operation: 'order.find.massive',
};
const $UserStateList = {
  url: URL_USERS_ONLINE,
  title: 'Сотрудники online',
  sortOrder: 29,
  eventKey: 29,
  operation: 'user.online',
};

const $TireFittingOrders = {
  url: URL_TIRE_FITTING_ORDERS,
  title: 'Заявки шиномонтажа',
  sortOrder: 30,
  eventKey: 30,
  operation: 'order.tire.fitting',
};

const $PartnerCarPark = {
  url: URL_PARTNER_CAR_PARK,
  title: 'Автопарк партнеров',
  sortOrder: 31,
  eventKey: 31,
  operation: 'reference.partner.car.park',
};

const $SettlementLosesOrders = {
  url: URL_LOSS_ADJUSTMENT_ORDERS,
  title: 'Заявки УУ',
  sortOrder: 32,
  eventKey: 32,
  operation: 'order.settlement.losses',
};

const $StatusNoticeAppointments = {
  url: URL_STATUS_NOTICE_APPOINTMENTS,
  title: 'Возвраты Совкомбанк',
  sortOrder: 33,
  eventKey: 33,
  operation: 'scheduler.status.notice',
};

const $VzrPolicies = {
  url: URL_VZR_POLICIES,
  title: 'Полисы',
  sortOrder: 31,
  eventKey: 31,
  operation: 'vzr.policies',
};
const $VzrPayments = {
  url: URL_VZR_PAYMENTS,
  title: 'Платежи',
  sortOrder: 32,
  eventKey: 32,
  operation: 'vzr.payments',
};
const $VzrPromoCodes = {
  url: URL_VZR_PROMOCODES,
  title: 'Промокоды',
  sortOrder: 33,
  eventKey: 33,
  operation: 'vzr.promocodes',
};

const $Partners = {
  url: URL_PARTNERS,
  title: 'Партнеры',
  sortOrder: 61,
  eventKey: 61,
  operation: 'reference.partner',
};
const $Divisions = {
  url: URL_DIVISIONS,
  title: 'Подразделения',
  sortOrder: 62,
  eventKey: 62,
  operation: 'reference.partner.division',
};
const $Insurance = {
  url: URL_INSURANCE,
  title: 'Страховые',
  sortOrder: 63,
  eventKey: 63,
  operation: 'reference.insuranceCompanies',
};
const $DocTemplates = {
  url: URL_DOC_TEMPLATES,
  title: 'Бланки для автозаполнения',
  sortOrder: 6301,
  eventKey: 6301,
  operation: 'reference.partner',
};
const $Users = {
  url: URL_USERS,
  title: 'Пользователи',
  sortOrder: 64,
  eventKey: 65,
  operation: 'reference.user',
};
const $Services = {
  url: URL_SERVICES,
  title: 'Сервисы',
  sortOrder: 65,
  eventKey: 65,
  operation: 'reference.service',
};
const $Positions = {
  url: URL_POSITIONS,
  title: 'Номенклатура',
  sortOrder: 66,
  eventKey: 66,
  operation: 'reference.service',
};
const $PriceLists = {
  url: URL_PRICELISTS,
  title: 'Прайс-листы',
  sortOrder: 67,
  eventKey: 67,
  operation: 'reference.pricelist',
};
const $PriceListOffices = {
  url: URL_PRICELIST_OFFICES,
  title: 'Привязка офиса к прайс-листу',
  sortOrder: 73,
  eventKey: 7302,
  operation: 'reference.pricelist.offices',
};

const $Roles = {
  url: URL_ROLES,
  title: 'Роли',
  sortOrder: 68,
  eventKey: 68,
  operation: 'reference.role',
};
const $Operations = {
  url: URL_OPERATIONS,
  title: 'Операции (функционал)',
  sortOrder: 69,
  eventKey: 69,
  operation: 'reference.operation',
};
const $Permissions = {
  url: URL_PERMISSIONS,
  title: 'Права по ролям',
  sortOrder: 70,
  eventKey: 70,
  operation: 'reference.permission',
};
const $PartnerPermissions = {
  url: URL_PARTNER_PERMISSIONS,
  title: 'Разрешения партнера',
  sortOrder: 71,
  eventKey: 71,
  operation: 'reference.partner.permission',
};
const $UniversalReference = {
  url: URL_UNIVERSAL_REFERENCE,
  title: 'Универсальный справочник',
  sortOrder: 72,
  eventKey: 72,
  operation: 'reference.universal',
};
const $SovcombankCheck = {
  url: URL_CHECK_SOVCOMBANK,
  title: 'Проверка Совкомбанк',
  sortOrder: 73,
  eventKey: 7301,
  operation: 'reference.pricelist.sovcombank.conrol',
};
const $VehicleChanges = {
  url: URL_VEHICLE_CHANGES,
  title: 'Изменения в автомобилях',
  sortOrder: 73,
  eventKey: 73,
  operation: 'order.vehicle.change',
};
const $CarmenCompatibility = {
  url: URL_CARMEN_COMPATIBILITY,
  title: 'Совместимость Carmen',
  sortOrder: 74,
  eventKey: 74,
  operation: 'reference.carmen.makes',
};
const $CarmenUsers = {
  url: URL_CARMEN_USERS,
  title: 'Сотрудники Carmen',
  sortOrder: 75,
  eventKey: 75,
  operation: 'reference.carmen.users',
};
const $ServiceCardTypes = {
  url: URL_SERVICE_CARD_TYPE,
  // Claude не разобрался в наименовении карт:
  title: 'Сервисные карты',
  sortOrder: 76,
  eventKey: 76,
  operation: 'reference.serviceCard.type',
};
const $PromoList = {
  url: URL_PROMO_REFERENCE,
  title: 'Промоакции',
  sortOrder: 77,
  eventKey: 77,
  operation: 'reference.promo',
};
const $SeoReference = {
  url: URL_SEO_PAGES_REFERENCE,
  title: 'SEO страницы',
  sortOrder: 78,
  eventKey: 78,
  operation: 'reference.seo.tree',
};
const $SeoReviewReference = {
  url: URL_SEO_REVIEW_REFERENCE,
  title: 'Отзывы',
  sortOrder: 79,
  eventKey: 79,
  operation: 'reference.seo.reviews',
};
const $SeoBlogReference = {
  url: URL_SEO_BLOG_REFERENCE,
  title: 'Блог',
  sortOrder: 80,
  eventKey: 80,
  operation: 'reference.seo.blog',
};
const $SeoBannerReference = {
  url: URL_SEO_BANNERS_REFERENCE,
  title: 'Баннеры',
  sortOrder: 81,
  eventKey: 81,
  operation: 'reference.seo.banner',
};
const $tyreReference = {
  url: URL_TYRE_REFERENCE,
  title: 'Шины',
  sortOrder: 82,
  eventKey: 82,
  operation: 'reference.tyre',
};
const $informerReference = {
  url: URL_INFORMERS,
  title: 'Информеры',
  sortOrder: 83,
  eventKey: 83,
  operation: 'reference.informer',
};

const $PostOffice = {
  url: URL_SCHEDULER_POST,
  title: 'Посты',
  sortOrder: 100,
  eventKey: 6001, // 60 -  eventKey из Scheduler + 01 -порядковый номер
  operation: 'reference.post.office',
};
const $WeekScheduler = {
  url: URL_SCHEDULER_WEEK,
  title: 'График на неделю',
  sortOrder: 110,
  eventKey: 6002, // 60 -  eventKey из Scheduler + 02 -порядковый номер
  operation: 'reference.post.office',
};
const $HalfYearScheduler = {
  url: URL_SCHEDULER_HALF_YEAR,
  title: 'График на полгода',
  sortOrder: 120,
  eventKey: 6003, // 60 -  eventKey из Scheduler + 03 -порядковый номер
  operation: 'reference.post.office',
};
const $SchedulerFederal = {
  url: URL_SCHEDULER_FEDERAL,
  title: 'Журнал записи',
  sortOrder: 130,
  eventKey: 6004, // 60 -  eventKey из Scheduler + 04 -порядковый номер
  operation: 'scheduler.federal',
};
const $SchedulerDeletedAppointments = {
  url: URL_SCHEDULER_DELETED_APPOINTMENTS,
  title: 'Удаленные записи',
  sortOrder: 140,
  eventKey: 6005,
  operation: 'scheduler.deleted',
};
const $SchedulerTimeline = {
  url: URL_SCHEDULER_TIMELINE,
  title: 'Расписание (УУ)',
  sortOrder: 150,
  eventKey: 6006,
  operation: 'scheduler.timeline',
};
const $SchedulerTimelineTireService = {
  url: URL_SCHEDULER_TIMELINE_TIRE_SERVICE,
  title: 'Расписание (шинный сервис)',
  sortOrder: 160,
  eventKey: 6007,
  operation: 'scheduler.timeline.tire.service',
};
const $SchedulerTireTransfer = {
  url: URL_SCHEDULER_TIRE_TRANSFER,
  title: 'Перемещения шин',
  sortOrder: 170,
  eventKey: 6008,
  operation: 'scheduler.tire.transfer',
};
// Записи «5 колеса» (виджет офисов «5 колеса»)
const $SchedulerTireFifthWheel = {
  url: URL_SCHEDULER_TIRE_FIFTH_WHEEL,
  title: 'Записи 5 колеса',
  sortOrder: 175,
  eventKey: 6009,
  operation: 'scheduler.tire.5wheel',
};
// Отчёты сервиса «А3» (оплата штрафов) выведены из меню как неактуальные —
// роуты /reports/a3* и URL-константы оставлены в routes.js на случай прямой ссылки.
const $clientRegistrationReport = {
  url: URL_REPORTS_CLIENT_REGISTRATION,
  title: 'Регистрация клиентов',
  sortOrder: 300,
  eventKey: 93,
  operation: 'report.clientRegistration',
};
const $settlementWithPartnerReport = {
  url: URL_REPORTS_SETTLEMENT_WITH_PARTNER,
  title: 'Отчет по партнерам',
  sortOrder: 400,
  eventKey: 94,
  operation: 'report.payment.partners',
};
const $reconciliationReport = {
  url: URL_REPORTS_RECONCILIATION,
  title: 'Акты взаиморасчета',
  sortOrder: 500,
  eventKey: 95,
  operation: 'reconciliation.act.main',
};
const $mobileStatisticsReport = {
  url: URL_REPORTS_MOBILE_STATISTICS,
  title: 'Статистика приложения',
  sortOrder: 600,
  eventKey: 96,
  operation: 'report.mobile.statistics',
};
const $operatorStatisticsReport = {
  url: URL_REPORTS_OPERATOR_STATISTICS,
  title: 'Статистика операторов',
  sortOrder: 700,
  eventKey: 97,
  operation: 'report.operator.statistics',
};
const $mobileStatisticsReportV2 = {
  url: URL_REPORTS_MOBILE_V2,
  title: 'Статистика приложения (v2)',
  sortOrder: 800,
  eventKey: 98,
  operation: 'report.mobile.statistics',
};
const $bonusesReport = {
  url: URL_REPORT_BONUSES,
  title: 'Отчет по бонусам',
  sortOrder: 900,
  eventKey: 99,
  operation: 'report.bonuses',
};
const $appointmentJournalUtmReport = {
  url: URL_UTM_REPORT_APPOINTMENTS,
  title: 'UTM в записях',
  sortOrder: 1100,
  eventKey: 991,
  operation: 'report.utm.appointment',
};
const $orderUtmReport = {
  url: URL_UTM_REPORT_ORDERS,
  title: 'UTM в заявках',
  sortOrder: 1200,
  eventKey: 992,
  operation: 'report.utm.order',
};
// Один роут и один код безопасности, два режима по списку услуг (постановка
// 2026-09-17): режим задаётся параметром ?serviceIds= (id через запятую),
// страница читает его и передаёт беку полем serviceIds. УУ — урегулирование
// убытков (61), ШМ — шиномонтажная группа (68 шиномонтаж, 69, 6).
const $sovcombankAppointmentsReport = {
  url: URL_SOVCOMBANK_APPOINTMENTS_REPORT,
  title: 'Аналитика записей(+Совкомбанк)',
  // Пока скрыт (hide у листьев поддержан в SideBarMenu): заменён режимами
  // УУ/ШМ ниже. Лист и роут живы — прямой url без параметра открывает отчёт
  // по всем сервисам.
  hide: true,
  sortOrder: 1250,
  eventKey: 9921,
  operation: 'report.sovkombank',
};
const $sovcombankUuAppointmentsReport = {
  url: `${ URL_SOVCOMBANK_APPOINTMENTS_REPORT }?serviceIds=61`,
  title: 'Аналитика записей(УУ)',
  sortOrder: 1251,
  eventKey: 9922,
  operation: 'report.sovkombank',
};
const $sovcombankShmAppointmentsReport = {
  url: `${ URL_SOVCOMBANK_APPOINTMENTS_REPORT }?serviceIds=68,69,6`,
  title: 'Аналитика записей(ШМ)',
  sortOrder: 1252,
  eventKey: 9923,
  operation: 'report.sovkombank',
};
// Аналитика заявок ШМ — заказы шиномонтажа с разбивкой по позициям счёта
// (svc-support, POST /v1/report/tire/service). Продолжение семейства отчётов
// «Аналитика записей» — размещено следом за его режимами УУ/ШМ.
const $tireServiceOrdersReport = {
  url: URL_TIRE_SERVICE_ORDERS_REPORT,
  title: 'Аналитика заявок ШМ',
  sortOrder: 1253,
  eventKey: 9924,
  operation: 'report.tireService.global',
};
// Аналитика хранения — заказы хранения шин, сервис 69 (svc-support, POST
// /v1/report/tire/storage). Продолжение «Аналитики заявок ШМ», размещено
// следом за ней; код безопасности тот же — аудитория отчётов совпадает.
const $tireStorageOrdersReport = {
  url: URL_TIRE_STORAGE_ORDERS_REPORT,
  title: 'Аналитика хранения',
  sortOrder: 1254,
  eventKey: 9925,
  operation: 'report.tireService.global',
};
// Аналитика клиентов — клиенты, зарегистрированные за период, с агрегатами по
// их заказам (svc-support, POST /v1/report/client/statistic). Продолжение
// семейства «Аналитика», размещено следом за «Аналитикой хранения». Код
// безопасности переиспользован у старого отчёта «Регистрация клиентов» —
// аудитория совпадает (прецедент: заявки ШМ и хранение делят report.tireService.global).
const $clientStatisticReport = {
  url: URL_CLIENT_STATISTIC_REPORT,
  title: 'Аналитика клиентов',
  sortOrder: 1255,
  eventKey: 9926,
  operation: 'report.clientRegistration',
};
const $evacuatorRefusalReport = {
  url: URL_EVACUATOR_REFUSAL_REPORT,
  title: 'Отказы в эвакуации',
  sortOrder: 1300,
  eventKey: 993,
  operation: 'report.evacuator.refusal',
};
const $tAvarcomReportReport = {
  url: URL_T_AVARCOM_REPORT,
  title: 'Т-Аварком (отчет)',
  sortOrder: 1400,
  eventKey: 994,
  operation: 'report.t.avarcom',
};
const $tAvarcomEvacuationReportReport = {
  url: URL_T_AVARCOM_EVACUATION_REPORT,
  title: 'Т-Аварком: эвакуация (отчет)',
  sortOrder: 1500,
  eventKey: 995,
  operation: 'report.t.avarcom',
};
const $tBankCheckReportReport = {
  url: URL_T_BANK_CHECK_REPORT,
  title: 'Т-Банк: оплаты',
  sortOrder: 1600,
  eventKey: 996,
  operation: 'report.tbank.check',
};
const $promoStatisticsReport = {
  url: URL_PROMO_STATISTICS_REPORT,
  title: 'Промо статистика',
  sortOrder: 1700,
  eventKey: 997,
  operation: 'report.promo.statistic',
};
const $bonusStatisticsReport = {
  url: URL_BONUS_STATISTICS_REPORT,
  title: 'Движение бонусов',
  sortOrder: 1800,
  eventKey: 998,
  operation: 'report.bonus.statistic',
};
const $wheelsStorageReport = {
  url: URL_WHEELS_STORAGE_REPORT,
  title: 'Хранение колес',
  sortOrder: 1900,
  eventKey: 998,
  operation: 'report.wheels.storage',
};
const $CheckTyreServiceReport = {
  url: URL_CHECK_TYRE_SERVICE_REPORT,
  title: 'Контроль шиномонтажа',
  sortOrder: 2000,
  eventKey: 999,
  operation: 'report.tyre.service',
};
const $PaidInvoicesReport = {
  url: URL_PAID_INVOICE_REPORT,
  title: 'Оплаченные счета',
  sortOrder: 2100,
  eventKey: 9990,
  operation: 'report.paid.invoice',
};
const $clientForMarketingReport = {
  url: URL_CLIENT_FOR_MARKETING_REPORT,
  title: 'Клиенты для маркетинга',
  sortOrder: 2200,
  eventKey: 9991,
  operation: 'report.client.marketing',
};
const $personalDataReport = {
  url: URL_PERSONAL_DATA_REPORT,
  title: 'Персональные данные',
  sortOrder: 2250,
  eventKey: 9997,
  operation: 'report.personal.data',
};
const $CheckTyreChangesReport = {
  url: URL_TYRE_CHANGES_REPORT,
  title: 'Перекидки колес',
  sortOrder: 2300,
  eventKey: 9992,
  operation: 'report.tyre.changes',
};
const $CheckSchedulerDurationReport = {
  url: URL_SCHEDULER_DURATION_REPORT,
  title: 'Продолжительность записи',
  sortOrder: 2400,
  eventKey: 9993,
  operation: 'report.scheduler.duration',
};

const $TireServiceReport = {
  url: URL_TIRE_SERVICE_REPORT,
  title: 'Статистика шинного сервиса',
  sortOrder: 2500,
  eventKey: 9994,
  operation: 'report.tire.service',
};

const $LossAdjustmentReport = {
  url: URL_LOSS_ADJUSTMENT_REPORT,
  title: 'Статистика УУ',
  sortOrder: 2600,
  eventKey: 9995,
  operation: 'report.loss.adjustment',
};

const $LossAdjustmentUserReport = {
  url: URL_LOSS_ADJUSTMENT_USER_REPORT,
  title: 'Статистика по сотрудникам (УУ)',
  sortOrder: 2700,
  eventKey: 9996,
  operation: 'report.loss.adjustment.user',
};

// Отчёты канала Т-Банк (мультиплатежи) — добавлены в master; в нашей IA размещены в разделе «Финансы»
const $TBankLegals = {
  url: URL_TBANK_LEGALS_REPORT,
  title: 'Юр.лица',
  sortOrder: 10,
  eventKey: 120010,
  operation: 'report.tbank.legals',
};

const $TBankMultiPayment = {
  url: URL_TBANK_MULTI_PAYMENTS,
  title: 'Выплаты',
  sortOrder: 11,
  eventKey: 120011,
  operation: 'report.tbank.multipayment.report',
};
const $QRCodes = {
  url: URL_QR_CODES,
  title: 'QR-коды дефектов шин',
  sortOrder: 100,
  eventKey: 11000,
  operation: 'qrcode.printer',
};

//  Бизнес просил 'Поиск по клиентам' и 'Поиск по авто' были в самом низу меню
const $ClientSearch = {
  url: URL_CLIENT_SEARCH,
  title: 'Поиск по клиентам',
  icon: 'search',
  sortOrder: 1000,
  eventKey: 70,
  operation: 'reference.person.card',
};
const $VehicleSearch = {
  url: URL_VEHICLE_SEARCH,
  title: 'Поиск по авто',
  icon: 'search',
  sortOrder: 1010,
  eventKey: 80,
  operation: 'reference.vehicle.findByNumber',
};

//  Объединённый раздел «Поиск»: раскрывается в выбор поиска по клиентам / по авто
const $Search = {
  url: emptyURL,
  title: 'Поиск',
  icon: 'search',
  sortOrder: 14,
  eventKey: 90,
  kids: [$ClientSearch, $VehicleSearch],
};

//  -------- top-level разделы (доменная группировка) --------
//  Подгруппа = объект { title, sortOrder, kids:[...] } внутри kids раздела:
//  рендерится как некликабельный подзаголовок + свои пункты (см. SideBarMenu.jsx).
//  Заголовок подгруппы скрывается, если у пользователя нет прав ни на один её пункт.

//  Кросс-сервисный оперативный хаб
const $AllOrders = {
  url: emptyURL,
  title: 'Заявки',
  icon: 'list-ul',
  sortOrder: 2,
  eventKey: 2,
  kids: [$Orders, $OrdersArchive, $FindOrdersByMassiveValues, $ContactExpired],
};

//  Шиномонтаж и хранение шин
const $TireService = {
  url: emptyURL,
  title: 'Шинный сервис',
  icon: 'car',
  sortOrder: 3,
  eventKey: 3,
  kids: [
    {
      title: 'Работа', sortOrder: 1, kids: [
        $TireFittingOrders,
        $StatusNoticeAppointments,
        $SchedulerTimelineTireService,
        $SchedulerTireTransfer,
        $SchedulerTireFifthWheel,
        $QRCodes,
      ], 
    },
    {
      title: 'Отчеты', sortOrder: 2, kids: [
        $CheckTyreServiceReport,
        $wheelsStorageReport,
        $CheckTyreChangesReport,
        $TireServiceReport,
      ], 
    },
  ],
};

//  Дорожная помощь: эвакуация/техпомощь + аваркомы + операционка канала Т-Банк
const $Evacuation = {
  url: emptyURL,
  title: 'Эвакуация и аваркомы',
  icon: 'truck',
  sortOrder: 4,
  eventKey: 4,
  kids: [
    {
      title: 'Заявки', sortOrder: 1, kids: [
        $EvacuatorOrders,
        $AvarcomOrders,
        $TBankAvarcomOrders,
        $TBankAvarcomEvacuationOrders,
      ], 
    },
    {
      title: 'Диспетчеризация', sortOrder: 2, kids: [
        $UserStateList,
        $PartnerCarPark,
      ], 
    },
    {
      title: 'Отчеты', sortOrder: 3, kids: [
        $evacuatorRefusalReport,
        $tAvarcomReportReport,
        $tAvarcomEvacuationReportReport,
      ], 
    },
  ],
};

//  Урегулирование убытков
const $LossAdjustment = {
  url: emptyURL,
  title: 'Урегулирование убытков',
  icon: 'wrench',
  sortOrder: 5,
  eventKey: 5,
  kids: [$SettlementLosesOrders, $SchedulerTimeline, $LossAdjustmentReport, $LossAdjustmentUserReport],
};

//  Страхование выезжающих за рубеж
const $Vzr = {
  url: emptyURL,
  title: 'ВЗР',
  icon: 'plane',
  sortOrder: 6,
  eventKey: 6,
  kids: [$VzrPolicies, $VzrPayments, $VzrPromoCodes],
};

//  Общие записи/расписание (не привязанные к одному домену)
const $Scheduler = {
  url: emptyURL,
  title: 'Расписание и записи',
  icon: 'calendar',
  sortOrder: 7,
  eventKey: 7,
  kids: [
    $SchedulerFederal,
    $SchedulerDeletedAppointments,
    $PostOffice,
    $WeekScheduler,
    $HalfYearScheduler,
    $CheckSchedulerDurationReport,
  ],
};

//  Аналитика (регистрации / операторы / приложение)
const $Analytics = {
  url: emptyURL,
  title: 'Аналитика',
  icon: 'line-chart',
  sortOrder: 8,
  eventKey: 8,
  kids: [
    $clientRegistrationReport,
    $operatorStatisticsReport,
    $mobileStatisticsReport,
    $mobileStatisticsReportV2,
    $sovcombankAppointmentsReport,
    $sovcombankUuAppointmentsReport,
    $sovcombankShmAppointmentsReport,
    $tireServiceOrdersReport,
    $tireStorageOrdersReport,
    $clientStatisticReport,
  ],
};

//  Финансы и расчёты с партнёрами (включая поступления по каналу Т-Банк)
const $Finance = {
  url: emptyURL,
  title: 'Финансы и партнеры',
  icon: 'credit-card',
  sortOrder: 9,
  eventKey: 9,
  kids: [
    {
      title: 'Взаиморасчеты', sortOrder: 1, kids: [
        $settlementWithPartnerReport,
        $reconciliationReport,
      ], 
    },
    {
      title: 'Бонусы', sortOrder: 2, kids: [
        $bonusesReport,
        $bonusStatisticsReport,
      ],
    },
  ],
};

//  Т-Банк
const $TBank = {
  url: emptyURL,
  title: 'T-Банк',
  icon: 'bank',
  sortOrder: 10,
  eventKey: 10,
  kids: [
    {
      title: 'Взаиморасчеты', sortOrder: 1, kids: [
        $PaidInvoicesReport,
        $tBankCheckReportReport,
      ], 
    },
    {
      title: 'Мультиплатежи Т-Банк', sortOrder: 3, kids: [
        $TBankLegals,
        $TBankMultiPayment,
      ],
    },
  ],
};

//  Бизнес-справочники (без админки и контента)
const $Refs = {
  url: emptyURL,
  title: 'Справочники',
  icon: 'book',
  sortOrder: 11,
  eventKey: 11,
  kids: [
    $Partners, $Divisions, $Insurance, $DocTemplates, $Services,
    $Positions, $PriceLists, $PriceListOffices, $tyreReference,
  ],
};

//  Маркетинг: программы/лояльность + контент + аналитика кампаний
const $Marketing = {
  url: emptyURL,
  title: 'Маркетинг и контент',
  icon: 'bullhorn',
  sortOrder: 12,
  eventKey: 12,
  kids: [
    {
      title: 'Программы и лояльность', sortOrder: 1, kids: [
        $PromoList,
        $ServiceCardTypes,
      ], 
    },
    {
      title: 'Контент', sortOrder: 2, kids: [
        $SeoReference,
        $SeoReviewReference,
        $SeoBlogReference,
        $SeoBannerReference,
        $informerReference,
      ], 
    },
    {
      title: 'Аналитика кампаний', sortOrder: 3, kids: [
        $clientForMarketingReport,
        $personalDataReport,
        $appointmentJournalUtmReport,
        $orderUtmReport,
        $promoStatisticsReport,
      ],
    },
  ],
};

const $Feedback = {
  url: URL_FEEDBACK,
  title: 'Обратная связь',
  sortOrder: 80,
  eventKey: 80,
  operation: 'feedback.console.manage',
};

//  Администрирование: доступы (RBAC), служебные справочники, интеграции
const $Administration = {
  url: emptyURL,
  title: 'Администрирование',
  icon: 'cog',
  sortOrder: 13,
  eventKey: 13,
  kids: [
    {
      title: 'Доступы', sortOrder: 1, kids: [
        $Users,
        $Roles,
        $Permissions,
        $Operations,
        $PartnerPermissions,
      ], 
    },
    {
      title: 'Справочники и интеграции', sortOrder: 2, kids: [
        $UniversalReference,
        $SovcombankCheck,
        $VehicleChanges,
        $CarmenCompatibility,
        $CarmenUsers,
      ],
    },
    {
      title: 'Обратная связь', sortOrder: 3, kids: [
        $Feedback,
      ],
    },
  ],
};

//  Бизнес просил поиски были в самом низу меню — объединённый раздел $Search внизу
export const NAVI = [
  { ...$Desktop },
  { ...$AllOrders },
  { ...$TireService },
  { ...$Evacuation },
  { ...$LossAdjustment },
  { ...$Vzr },
  { ...$Scheduler },
  { ...$Analytics },
  { ...$Finance },
  { ...$TBank },
  { ...$Refs },
  { ...$Marketing },
  { ...$Administration },
  { ...$Search },
];
